import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { CustomerStoryModel } from '@smarttask-common/src/lib/models/Prismic/CustomerStory/CustomerStoryModel';

export enum CustomerStoryActionTypes {
    ADD_CUSTOMER_STORY = '[CustomerStory] Create CustomerStory',
    ADD_CUSTOMER_STORIES = '[CustomerStories] Add CustomerStories',
    UPSERT_CUSTOMER_STORY = '[CustomerStory] Upsert CustomerStory',
    UPSERT_CUSTOMER_STORIES = '[CustomerStories] Upsert CustomerStories',
    UPDATE_CUSTOMER_STORY = '[CustomerStory] Update CustomerStory',
    UPDATE_CUSTOMER_STORIES = '[CustomerStories] Update CustomerStories',
    DELETE_CUSTOMER_STORY = '[CustomerStory] Delete CustomerStory',
    DELETE_CUSTOMER_STORIES = '[CustomerStories] Delete CustomerStories',
    DELETE_ALL_CUSTOMER_STORIES = '[CustomerStories] Delete All CustomerStories',
    DELETE_ALL = '[CustomerStory] Delete All',

    UPDATE_SELECTED_ID = '[CustomerStory] Update SelectedId',
}

export class UpdateSelectedCustomerStoryId implements Action {
    readonly type = CustomerStoryActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_customer_story_uid: string) {}
}

export class AddOne implements Action {
    readonly type = CustomerStoryActionTypes.ADD_CUSTOMER_STORY;
    constructor(public customer_story: CustomerStoryModel) {}
}

export class AddMany implements Action {
    readonly type = CustomerStoryActionTypes.ADD_CUSTOMER_STORIES;
    constructor(public customer_stories: Array<CustomerStoryModel>) {}
}

export class UpsertOne implements Action {
    readonly type = CustomerStoryActionTypes.UPSERT_CUSTOMER_STORY;

    constructor(public customer_story: CustomerStoryModel) {}
}

export class UpsertMany implements Action {
    readonly type = CustomerStoryActionTypes.UPSERT_CUSTOMER_STORIES;
    constructor(public customer_stories: Array<CustomerStoryModel>) {}
}

export class UpdateOne implements Action {
    readonly type = CustomerStoryActionTypes.UPDATE_CUSTOMER_STORY;
    constructor(public customer_story: Update<CustomerStoryModel>) {}
}

export class UpdateMany implements Action {
    readonly type = CustomerStoryActionTypes.UPDATE_CUSTOMER_STORIES;
    constructor(public customer_stories: Array<Update<CustomerStoryModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = CustomerStoryActionTypes.DELETE_CUSTOMER_STORY;
    constructor(public uid: string) {}
}

export class DeleteMany implements Action {
    readonly type = CustomerStoryActionTypes.DELETE_CUSTOMER_STORIES;
    constructor(public uids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = CustomerStoryActionTypes.DELETE_ALL_CUSTOMER_STORIES;
    constructor(public uids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = CustomerStoryActionTypes.DELETE_ALL;
    constructor() {}
}

export type CustomerStoryActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedCustomerStoryId;
